import React from 'react';
import { useSettingsViewModel } from './settings/viewmodel/settings-viewmodel';
import StoreInformation from './settings/components/StoreInformation';
import Notification from './settings/components/Notification';

const SettingsPage = () => {
  const {
    storeInfo,
    isLoading,
    isSaving,
    notification,
    error,
    handleSaveStoreInfo,
    clearNotification,
    retryLoading
  } = useSettingsViewModel();

  return (
    <div className="py-6 px-4 sm:px-6 lg:px-8">
      <div>
        <p className="mt-2 text-sm text-gray-700">
          Configurez les paramètres de votre boutique, notifications et préférences.
        </p>
      </div>
      
      {/* Notification area */}
      {notification && (
        <div className="mt-4">
          <Notification
            type={notification.type}
            message={notification.message}
            onClose={clearNotification}
          />
        </div>
      )}
      
      {/* Error state with retry */}
      {error && (
        <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-md">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-red-800">{error}</p>
            </div>
            <div className="ml-auto pl-3">
              <button
                onClick={retryLoading}
                className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Réessayer
              </button>
            </div>
          </div>
        </div>
      )}
      
      <div className="mt-6 space-y-8">
        {isLoading ? (
          <div className="py-12 flex justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#174540]"></div>
          </div>
        ) : (
          <>
            {/* Store Information Section */}
            <StoreInformation
              storeInfo={storeInfo}
              onSave={handleSaveStoreInfo}
              isSaving={isSaving}
            />
            
            {/* Other sections can be added here as separate components */}
          </>
        )}
      </div>
    </div>
  );
};

export default SettingsPage;